import React, { useEffect, useState } from "react";
import axios from "axios";

function WalletConnect() {
  const [isKasWareAvailable, setIsKasWareAvailable] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);
  const [account, setAccount] = useState(null);
  const [balance, setBalance] = useState(null);
  const [amountToSend, setAmountToSend] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [txid, setTxid] = useState(null);
  const toAddress =
    "kaspa:qzk0z20m7sm7rm35yvzpuv8a5pzlzgur5yn90f65lm4err50ujn9s8pr6ltpz";

  useEffect(() => {
    if (typeof window.kasware !== "undefined") {
      setIsKasWareAvailable(true);
      console.log("KasWare Wallet is installed!");
    } else {
      console.log("KasWare Wallet is not installed.");
    }
  }, []);

  const connectWallet = async () => {
    if (!isKasWareAvailable || isConnecting) return;
    setIsConnecting(true);

    try {
      let accounts = await window.kasware.requestAccounts();
      console.log("Connect success", accounts);
      setAccount(accounts[0]);
      await fetchBalance();
    } catch (error) {
      console.error("Connect failed", error);
    } finally {
      setIsConnecting(false);
    }
  };

  const fetchBalance = async () => {
    try {
      let res = await window.kasware.getBalance();
      console.log("Balance", res);
      setBalance(res.total / 1e8);
    } catch (error) {
      console.error("Failed to get balance", error);
    }
  };

  const handleAmountChange = (event) => {
    setAmountToSend(event.target.value);
  };

  const sendKAS = async () => {
    if (!account || amountToSend <= 0) {
      alert("Please enter a valid amount to send.");
      return;
    }

    const sompiAmount = amountToSend * 1e8;

    try {
      setIsSending(true);
      let txResponse = await window.kasware.sendKaspa(toAddress, sompiAmount);
      if (typeof txResponse === "string") {
        txResponse = JSON.parse(txResponse);
      }

      setTxid(txResponse.id || txResponse.transactionId);
      setAmountToSend(0);
      await fetchBalance();
    } catch (error) {
      console.error("Failed to send KAS", error);
      alert("Failed to send KAS.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="send_kasware">
      <h3 className="progressbar_title">Use Kasware wallet to send KAS</h3>

      {isKasWareAvailable ? (
        <div>
          {account ? (
            <div>
              <p>
                Connected account: <span> {account}</span>
              </p>
              {balance !== null ? (
                <p>Balance: {balance.toFixed(2)} KAS</p>
              ) : (
                <p>Loading balance...</p>
              )}

              <div className="slider_container">
                <input
                  type="range"
                  min="0"
                  max={balance || 0}
                  value={amountToSend}
                  onChange={handleAmountChange}
                  className="slider"
                />
                <p>
                  Amount to send: <span>{amountToSend} KAS</span>
                </p>
              </div>

              <button
                className="font-bold send_button button"
                onClick={sendKAS}
                disabled={isSending || amountToSend <= 0}
              >
                {isSending ? "Sending..." : "Send KAS"}
              </button>

              {txid && (
                <p className="mt-4">
                  Transaction successful! View on{" "}
                  <a
                    href={`https://explorer.kaspa.org/txs/${txid}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 underline"
                  >
                    Kaspa Explorer
                  </a>
                </p>
              )}
            </div>
          ) : (
            <button
              className="font-bold button"
              onClick={connectWallet}
              disabled={isConnecting}
            >
              {isConnecting ? "Connecting..." : "Connect wallet"}
            </button>
          )}
        </div>
      ) : (
        <p className="infos_send">Please install KasWare Wallet to connect.</p>
      )}
    </div>
  );
}

export default WalletConnect;
